import {useLocaleStore} from "~/stores/locale";

export default defineNuxtPlugin(nuxt => {

	const localeStore = useLocaleStore()
	document.documentElement.setAttribute('lang', localeStore.locale || 'no')
})
